import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GATrackingPLPCategoryExpandedNavigationEvent implements GATrackingEvent {

  constructor(private showAllText: string) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.PLPCategoryNavigationExpanded;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.Navigation,
      label: this.showAllText,
    };
  }
}
